import { render, staticRenderFns } from "./RecordStreamax.vue?vue&type=template&id=c4701584&scoped=true&"
import script from "./RecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./RecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./RecordStreamax.vue?vue&type=style&index=0&id=c4701584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4701584",
  null
  
)

export default component.exports